import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

/**
 * BlueprintCtaCard - inline conversion card inserted between articles in the
 * Relo News grid (and reusable elsewhere). Captures a warmed-up reader at the
 * moment they're imagining their own move.
 *
 * Golden Hour #E8A830 background, Cormorant Garamond italic headline,
 * Outfit 300 subhead, Golden CTA → /start.
 */
const BlueprintCtaCard = () => (
  <div
    className="group relative overflow-hidden bg-[#E8A830] flex flex-col justify-between p-8 md:p-10 aspect-[4/3] transition-shadow hover:shadow-xl"
    data-testid="news-cta-card"
  >
    {/* Soft radial texture overlay so it doesn't read as a flat banner */}
    <div
      className="absolute inset-0 opacity-30 pointer-events-none"
      style={{
        background:
          'radial-gradient(circle at 20% 0%, rgba(255,255,255,0.4) 0%, transparent 50%), radial-gradient(circle at 80% 100%, rgba(10,31,46,0.15) 0%, transparent 50%)',
      }}
      aria-hidden="true"
    />

    <div className="relative">
      <div className="inline-flex items-center gap-1.5 font-mono uppercase text-[10px] tracking-[0.18em] text-[#0A1F2E] mb-4">
        <Sparkles className="w-3.5 h-3.5" />
        Free · 8 minutes
      </div>
      <h3 className="font-display italic text-3xl md:text-4xl text-[#0A1F2E] leading-[1.05]">
        Ready to make your move?
      </h3>
      <p className="font-body text-[#0A1F2E]/85 mt-3 max-w-xs text-base leading-relaxed">
        Get your free personalized relocation plan in 8 minutes.
      </p>
    </div>

    <div className="relative">
      <Link
        to="/start-trial"
        className="inline-flex items-center gap-2 bg-[#0A1F2E] hover:bg-[#1A5C6E] text-[#F9F6EF] px-5 py-3 rounded-full font-mono uppercase text-[11px] tracking-[0.12em] font-semibold transition group-hover:translate-x-0.5"
        data-testid="news-cta-btn"
      >
        Start free - 15 days <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </div>
);

export default BlueprintCtaCard;
